export default __webpack_public_path__ + "static/media/meycologo.98a0b16f.jpg";